var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({attrs:{"type":"submit","name":_vm.field.handle,"disabled":_vm.instance.sending}},'button',_vm.attributes,false),[(_vm.instance.sending)?_c('span',[_c('div',{staticClass:"loading",attrs:{"id":"loader-1"}})]):_c('span',[_vm._v("\n        "+_vm._s(_vm.field.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }